import type { UserProfile } from '../contexts/AuthContext';

interface ImpersonationLike {
  active?: boolean;
  farm_name?: string | null;
}

/**
 * The name the header shows: the impersonated farm while impersonating, else the farm the person
 * is working in (HOF-627 — after a switch the requests go there, so the header names it, not the
 * founder's legacy `farm_name`). An explicit `active_farm: null` (no farm) falls back to the phone;
 * the legacy field only stands in when the server sends no `active_farm` at all.
 */
export function headerName(
  profile: Pick<UserProfile, 'farm_name' | 'active_farm'> | null | undefined,
  impersonation: ImpersonationLike | null | undefined,
  phone: string | null | undefined,
): string {
  if (impersonation?.active) {
    return impersonation.farm_name || 'Impersonating...';
  }
  const farmName = profile?.active_farm !== undefined ? profile.active_farm?.farm_name : profile?.farm_name;
  return farmName || phone || '';
}
